<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  name: 'UserDetailsManagerForm',
  props: ['validation'],
  async mounted () {
    await this.$store.dispatch('courses/fetchAll')
    // if(this.isUserWizard && this.$p(['RECRUITER'])) {
    //   this.updateAffiliateForm({ field: 'RECRUITER_ID', value: this.recruiterOptions[0].value})
    // }
  },
  data () {
    return {
    }
  },
  computed: {
    // ...mapState({
    //   courseOptions: state => state.courses.courseOptions
    // }),
    ...mapState('users', {
      userForm: state => state.userForm,
      addressForm: state => state.addressForm,
      studentForm: state => state.affiliateForm,
      canEdit: state => state.userModal.canEdit,
    }),
    ...mapGetters('users', [
      'administratorOptions',
      'managerCourseIds'
    ]),
    ...mapGetters({
      courseOptions: "courses/courseOptions"
    }),
  },
  methods: {
    ...mapMutations('users', [
      'updateUserForm',
      'updateAddressForm',
      'updateManagerForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ])
  }
}
</script>

<template>
  <div>
    <div class="row">
      <h6 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-book"></q-icon>Courses
      </h6>
      <q-field class="q-pa-md col-12">
        <q-select
          chips
          multiple
          float-label="Courses"
          :value="managerCourseIds"
          :options="courseOptions"
          filter
          autofocus-filter
          :disable="!canEdit"
          @input="managerCourseIds => this.updateManagerForm({
            field: 'COURSES',
            value: managerCourseIds.map(courseId => { 
              return { COURSE_ID: courseId } 
            })
          })"
        />
      </q-field>
    </div>
  </div>
</template>

<style>
</style>
